<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block">{{heading}} Template Task</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <ng-container>
        <div style="padding: 16px 24px 16px 24px;">
            <div class="row">
                <div class="col-md-6 col-pd-r">
                    <div>
                        <label class="catlabel"> Task
                            <span style="color:#ff0000">*</span>
                        </label>
                        <div class="content-task">
                            <mat-form-field appearance="outline" class="fixed-select">
                                <mat-select [(ngModel)]="selectedTask" [ngModelOptions]="{ standalone: true }"
                                    panelClass="custom-task-panel" [disableOptionCentering]="true"
                                    placeholder="Select">
                                    <mat-option disabled>
                                        <ngx-mat-select-search [formControl]="taskFilter"
                                            placeholderLabel="Search Tasks" noEntriesFoundLabel="No matching task"
                                            [clearSearchInput]="true" style="width: 100%;">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let task of filteredTasks | async" [value]="task">
                                        {{ task.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <label class="catlabel"> D-Day
                        </label>
                        <div class="content-task">
                            <input type="text" id="dDay" name="dDay" required [(ngModel)]="selected_dday">
                        </div>
                    </div>
                    <div>
                        <label class="catlabel"> Due Time
                            <p class="due-desc">(Leave blank for midnight)</p>
                        </label>
                        <div class="content-task">
                            <select class="F1" id="category-drop-down" [(ngModel)]="selected_duetime">
                                <option [value]="option" *ngFor="let option of options">{{option}}</option>
                            </select>
                        </div>
                    </div>
                    <div>
                        <label class="catlabel"> Sequence
                        </label>
                        <div class="content-task">
                            <input type="number" id="sequence" name="sequence" required min="0"
                                [(ngModel)]="selected_sequence" max="99">
                        </div>
                    </div>
                    <div>
                        <label class="catlabel"> Primary User
                        </label>
                        <div class="content-task">
                            <mat-form-field appearance="outline" class="fixed-select">
                                <mat-select [(ngModel)]="selected_puser" placeholder="Select" name="puser">
                                    <mat-option disabled><ngx-mat-select-search [formControl]="puserFilter"
                                            placeholderLabel="Search" noEntriesFoundLabel="No User found"
                                            style="flex: 1;">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let user of filteredPusers | async" [value]="user">
                                        {{ user.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <label class="catlabel"> Secondary User </label>
                        <div class="content-task">
                            <mat-form-field appearance="outline" class="fixed-select">
                                <mat-select [(ngModel)]="selected_suser" placeholder="Select">
                                    <mat-option disabled>
                                        <div
                                            style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
                                            <ngx-mat-select-search [formControl]="suserFilter"
                                                placeholderLabel="Search" noEntriesFoundLabel="No User found"
                                                style="flex: 1;">
                                            </ngx-mat-select-search>
                                        </div>
                                    </mat-option>
                                    <div style="max-height: 200px; overflow-y: auto;">
                                        <mat-option *ngFor="let user of filteredSusers | async" [value]="user">
                                            {{ user.label }}
                                        </mat-option>
                                    </div>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-pd-r">
                    <div>
                        <label class="catlabel"> Region
                        </label>
                        <div class="content-task">
                            <mat-form-field appearance="outline" class="fixed-select">
                                <mat-select [(ngModel)]="selected_region" [multiple]="true"
                                    placeholder="Select Region(s)">
                                    <mat-option disabled style="margin-left: -10px;">
                                        <div style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;"
                                            class="temptask">
                                            <mat-checkbox style="margin-right: 8px;" [checked]="isAllSelected()"
                                                [indeterminate]="isIndeterminate()"
                                                (change)="toggleSelectAll($event)">
                                            </mat-checkbox>
                                            <ngx-mat-select-search [formControl]="regionFilterCtrl"
                                                placeholderLabel="Search" noEntriesFoundLabel="No regions found"
                                                style="flex: 1;">
                                            </ngx-mat-select-search>
                                        </div>
                                    </mat-option>
                                    <div style="max-height: 200px; overflow-y: auto;">
                                        <mat-option *ngFor="let user of filteredRegions | async" [value]="user">
                                            {{ user.label }}
                                        </mat-option>
                                    </div>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <label *ngIf="enableError" class="errormsg"> {{errormsg}} </label>
        </div>
        <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
            <button (click)="onNoClick()" class="mCancel"> CANCEL
            </button>
            <button class="taskm-submit" style="display: inline" (click)="saveClick()">
                SAVE
            </button>
        </div>
    </ng-container>
</div>